import { lazy, Suspense } from 'react';
import { Outlet, createRoute } from '@tanstack/react-router';

import DashboardLayout from 'src/layouts/dashboard';

import AppAuthGuard from 'src/components/auth/app-auth-guard';
import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import { ProductsListSearchParamsSchema } from 'src/sections/product/product-list/view';

import { rootRoute } from './root';

const ProductsList = lazy(() => import('src/sections/product/product-list/view'));
const ProductDetails = lazy(() => import('src/sections/product/product-details/view'));

// Products routes
const productsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'products',
  component: () => (
    <AppAuthGuard splashScreen={<SplashScreen />}>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AppAuthGuard>
  ),
});

const productsIndexRoute = createRoute({
  getParentRoute: () => productsRoute,
  path: '/',
  component: ProductsList,
  validateSearch: (search) =>
    ProductsListSearchParamsSchema.validateSync(search, { stripUnknown: true }),
});

const productDetailsRoute = createRoute({
  getParentRoute: () => productsRoute,
  path: '$stockId',
});

const productDetailsIndexRoute = createRoute({
  getParentRoute: () => productDetailsRoute,
  path: '/',
  component: ProductDetails,
});

const componentDetailsRoute = createRoute({
  getParentRoute: () => productDetailsRoute,
  path: '$componentId',
  component: ProductDetails,
});

export const productsRouteTree = productsRoute.addChildren([
  productsIndexRoute,
  productDetailsRoute.addChildren([productDetailsIndexRoute, componentDetailsRoute]),
]);
